import moment from 'moment';
import momentTimeZone from 'moment-timezone';
const VITE_CHUBB_TIME_ZONE_MEXICO: string = import.meta.env.VITE_CHUBB_TIME_ZONE_MEXICO
const VITE_CHUBB_TIME_ZONE_CHILE: string = import.meta.env.VITE_CHUBB_TIME_ZONE_CHILE


function isTimeGreaterThan90MinutesFromNow(dateStr: string, timeStr: string, timeZone: string) {
  const formattedDate = moment(dateStr).format('YYYY-MM-DD');

    // Crear el momento objetivo con la fecha, hora y zona horaria
    const targetTime = momentTimeZone.tz(`${formattedDate} ${timeStr}`, 'YYYY-MM-DD HH:mm', timeZone);
    const currentTime = moment().tz(timeZone);

    // Calculate the difference in minutes between the target time and the current time in the comparison time zone
    const differenceInMinutes = targetTime.diff(currentTime, 'minutes');

    // Check if the difference is greater than 90 minutes
    return differenceInMinutes < 90;
  }

  export const wrongDepartureDateTime = (date: string, time: string, timeZone: 'cl' | 'mx'): boolean => {
    const timeZoneSelected = {
      'cl': VITE_CHUBB_TIME_ZONE_CHILE,
      'mx': VITE_CHUBB_TIME_ZONE_MEXICO
    };

    const selectedTimeZone = timeZoneSelected[timeZone] || VITE_CHUBB_TIME_ZONE_MEXICO;

    const result = isTimeGreaterThan90MinutesFromNow(date, time, selectedTimeZone);

    return result;
  };